import { Language } from "@mui/icons-material";
import { ROUTES } from "app/frontend/constants/routes";
import { ReactNode } from "react";

import HeaderButtonContent from "@frontend/components/static/header/HeaderButtonContent";
import ContactIcon from "app/frontend/assets/icons/icn-contact.svg?react";
import { IHeaderButtonContentProps, IPage } from "../header/types";

// NOTE: These are hidden as of 10/1/2025 because they are not implemented in this project
// Keeping them here in case they are needed in the future.
export const EXTERNAL_PAGES: {
  title: string;
  icon: () => ReactNode;
  url: string;
}[] = [
  {
    title: "Contact Us",
    icon: () => <ContactIcon width="14px" fill="white" />,
    url: "#",
  },
  {
    title: "Languages",
    icon: () => <Language />,
    url: "#",
  },
];

export const PAGES: IPage[] = [
  {
    name: (props: Omit<IHeaderButtonContentProps, "title">) => (
      <HeaderButtonContent {...props} title="Residential" />
    ),
    routes: {
      main: "#",
    },
    children: [
      {
        title: "Understanding Residential Rates",
        route: ROUTES.Rates.ROOT,
      },
      // {
      //   title: "Time-of-Use Rate Calculator",
      //   route: ROUTES.Rates.TOUCalculator,
      // },
    ],
  },
  {
    name: (props: Omit<IHeaderButtonContentProps, "title">) => (
      <HeaderButtonContent {...props} title="Commercial & Industrial" />
    ),
    routes: {
      main: "#",
    },
    children: [
      {
        title: "Understanding the Basics",
        route: ROUTES.Rates.CommercialIndustrial.Basics,
      },
      {
        title: "Demand Charges",
        route: ROUTES.Rates.CommercialIndustrial.DemandCharges,
      },
      {
        title: "Smart Usage Rewards",
        route: ROUTES.Rates.CommercialIndustrial.DemandResponse,
      },
    ].filter(Boolean) as IPage["children"],
  },
  {
    name: (props: Omit<IHeaderButtonContentProps, "title">) => (
      <HeaderButtonContent {...props} title="Contractors & Developers" />
    ),
    routes: {
      main: ROUTES.PowerReady.ROOT,
    },
    children: [
      {
        title: "PowerReady Eligibility Assessment",
        route: ROUTES.PowerReady.Eligibility.ROOT,
      },
      {
        title: "PowerReady Incentive Estimator",
        route: ROUTES.PowerReady.Projects.ROOT,
      },
      { title: "DAC Screener", route: ROUTES.PowerReady.DacScreenerPage },
      { title: "LMI Eligibility", route: ROUTES.PowerReady.LmiEligibility },
      { title: "Contact Us", route: ROUTES.PowerReady.Contact },
    ],
  },
  {
    name: (props: Omit<IHeaderButtonContentProps, "title">) => (
      <HeaderButtonContent {...props} title="Resources" />
    ),
    routes: {
      main: "#",
    },
    children: [
      { title: "Residential Resources", route: ROUTES.Rates.ResourceCenter },
      {
        title: "PowerReady Resources",
        route: ROUTES.PowerReady.ResourceCenter,
      },
    ],
  },
  // Issue 231 - Remove "Home" from header. This could change so we'll just hide it for now.
  // {
  //   name: ({isSelected}: IHeaderButtonContentProps) => (
  //     <HeaderButtonContent
  //       title={"Home"}
  //       icon={
  //         <>
  //           <HomeIcon />
  //           &nbsp;
  //         </>
  //       }
  //       {...props}
  //       isBlue
  //     />
  //   ),
  //   routes: {
  //     main: "https://www.coned.com",
  //   },
  //   children: [],
  //   isBlue: true,
  // },
];
